import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance_create_new_claim = get_axios_instance(api_variables.SERVICE_CREATE_NEW_CLAIM);
var axios_instance_update_new_claim = get_axios_instance(api_variables.SERVICE_UPDATE_NEW_CLAIM);
var axios_instance_get_list_new_claim = get_axios_instance(api_variables.SERVICE_GET_LIST_NEW_CLAIM);
var axios_instance_upload_proof_new_claim = get_axios_instance(api_variables.SERVICE_UPLOAD_PROOF_NEW_CLAIM);
var axios_instance_get_listone_id_new_claim = get_axios_instance(api_variables.SERVICE_GET_LISTONE_NEW_CLAIM_ID);
var axios_instance_get_fbp_list = get_axios_instance(api_variables.SERVICE_GET_FBP_COMPONENT_LIST);
var axios_instance_get_fbp_list_data = get_axios_instance(api_variables.SERVICE_GET_FBP_COMPONENT_LIST_DATA);
var axios_intsace_get_component_monthly_value = get_axios_instance(api_variables.SERVICE_FBP_COMPONENTLIST_CLAIM)
var axios_instance_get_claim_template = get_axios_instance(api_variables.SERVICE_FBP_DOWNLOAD_BULK_CLAIMS);
var axios_instance_uplaod_claim_template = get_axios_instance(api_variables.SERVICE_FBP_UPLOAD_BULK_CLAIMS);
var axios_instance_upload_bill = get_axios_instance(api_variables.SERVICE_UPLOAD_FBP);

const _pk_name = "id";

const state = {
    data: [],
    employeeData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};
const getters = {

}
const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },
 
    setEmployeeData: (state, payload) => {
        if (payload) {
            state.employeeData = payload;
        }
        //console.log('fetched exits', state.employeeData)
    },
    updateEmployeeFBPClaimsById: (state, payload) => {
        //console.log(payload);
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async create({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create_new_claim.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/payroll/addnewclaim/create] res: ", res);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch (error){
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_update_new_claim.put(``, payload);
            commit("setSaving", false);
            //console.log("[state/payroll/addnewclaim/update] res: ", res);
            if (res.status == 200) {
                commit("updateEmployeeFBPClaimsById", res.data);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/fetchAll] Calling API...", payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance_get_list_new_claim.get(`/${payload}`
                // {
                //     params: {
                //         legal_entity_id:payload
                //       }
                //   }
            );

            commit("setFetching", false);
            //console.log("[state/payroll/addnewclaim/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchEmployeeByNewClaimID({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/update]", payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance_get_listone_id_new_claim.get(`/${payload}`);
            //console.log("Checking response", res);
            commit("setFetching", false);
            //console.log("[state/payroll/addnewclaim/update] ", res);
            //   if(res.status == 200) {
            //     commit("set", payload);
            //   }
            commit("set", res.data.rows);
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    // async delete({ commit }, payload) {
    //     //console.log("[state/payroll/settle_fbp_claims/delete] Payload:", payload);
    //     //console.log("[state/payroll/settle_fbp_claims/delete] Payload:", `/${payload.id}`);
    //     try {
    //         commit("setDeleting", true);
    //         let res = await axios_instance.delete(`/${payload.id}`);
    //         commit("setDeleting", false);
    //         if (res.status == 200) {
    //             commit("removeEmployeeById", payload.id);
    //         }
    //     } catch {

    //     }
    // }

    async fetchAllComponentList({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/fetchAll] Calling API...", payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance_get_fbp_list.get(``, {
                params: {
                    le_id: payload
                }
            });

            commit("setFetching", false);
            //console.log("[state/payroll/addnewclaim/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchAllFbpList({ commit }, payload) {
        //console.log("fetchAllFbpList--JS File...", payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance_get_fbp_list_data.get(`/${payload}`
                // {
                //     params: {
                //         legal_entity_id:payload
                //       }
                //   }
            );

            commit("setFetching", false);
            //console.log("fetchAllFbpList--JS File...", res);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchFbpcomponentMonthlyValue({ commit }, payload) {
        //console.log("i am action new one", payload)
        try {
            commit("setFetching", true);
            let res = await axios_intsace_get_component_monthly_value.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                //commit("set", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async getClaimsTemplate({commit},payload) {
        try {
          let res = await axios_instance_get_claim_template.get(``, );
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "FBP Claims"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(err);
        }
    },

    async fbpClaimsUploadTemplate({ commit }, payload) {
        try {
            console.log('entry');
            commit("setFetching", true);
            let res = await axios_instance_uplaod_claim_template.post(``, payload);
            commit("setFetching", false);
            console.log(res, 'res');
            return res;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    },

    async fbpBillsUploadMethod({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_bill.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            return err.response;
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}